import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import messages from "./messages";
import { Close } from "@material-ui/icons";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));

function ContactRefrezhModal({ isOpen = false, onClose }) {
  const classes = useStyles();

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>
        <div className={classes.header}>
          <div>
            <FormattedMessage {...messages.contact_refrezh_title} />
          </div>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <p>
          <FormattedMessage {...messages.contact_refrezh_text} />
        </p>
        <p>
          <FormattedMessage {...messages.contact_refrezh_contact} />
        </p>
      </DialogContent>
    </Dialog>
  );
}

ContactRefrezhModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default ContactRefrezhModal;
